/// <amd-module name="Test/TestCaseResultsFilter/TestCaseResultsFilterComponent" />
import * as React from "react";
import { ITestCaseResultsFilterComponentProps, ITestCaseResultsFilterItem } from "TestCaseResultsFilterComponent.Types";
import { IObservableValue } from "VSS/Core/Observable";
import { VssComponent } from "VSS/Platform/Layout";
import { DropdownFilterBarItem } from "VSSUI/Dropdown";
import { FilterBar } from "VSSUI/FilterBar";
import { Observer } from "VSSUI/Observer";
import { FilterContext, IFilter } from "VSSUI/Utilities/Filter";

export class TestCaseResultsFilterComponent extends React.Component<ITestCaseResultsFilterComponentProps> {
    public render(): JSX.Element {
        return (
            <FilterContext.Consumer>
                {(value: { filter: IFilter; filterToggled: IObservableValue<boolean> }) => (
                    <Observer value={value.filterToggled}>
                        {() => {
                            return value.filterToggled.value ? (
                                <FilterBar className={this.props.className} filter={value.filter}>
                                    {this._renderFilterFields(value.filter)}
                                </FilterBar>
                            ) : null;
                        }}
                    </Observer>
                )}
            </FilterContext.Consumer>
        );
    }

    private _renderFilterFields(filter: IFilter): JSX.Element[] {
        const filterBarItemsToRender: JSX.Element[] = [];
        if (this.props.filterBarItems && this.props.filterBarItems.length > 0) {
            for (const filterBarItem of this.props.filterBarItems) {
                const filterItemToRender: JSX.Element = this._getFilterItemToRender(filterBarItem, filter);
                filterBarItemsToRender.push(filterItemToRender);
            }
        }

        return filterBarItemsToRender;
    }

    private _getFilterItemToRender(filterBarItemProps: ITestCaseResultsFilterItem, filter: IFilter): JSX.Element {
        let filterBarItemToRender: JSX.Element = <></>;
        if (filterBarItemProps) {
            filterBarItemToRender = (
                <DropdownFilterBarItem
                    key={filterBarItemProps.key}
                    filter={filter}
                    filterItemKey={filterBarItemProps.filterItemKey}
                    placeholder={filterBarItemProps.placeholder}
                    selection={filterBarItemProps.selection}
                    items={filterBarItemProps.items}
                    width={filterBarItemProps.width}
                />
            );
        }

        return filterBarItemToRender;
    }
}

VssComponent.register("testcase-results-filter-component", TestCaseResultsFilterComponent);
